import axios from "axios";
import { toast } from "react-toastify";

const axiosPublicRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosPublicRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const detailStr = error?.response?.data?.detail;
    const fixedJsonStr = detailStr.replace(/'/g, '"');

    const detailObj = JSON.parse(fixedJsonStr);

    toast.error(detailObj?.message || "Хатогӣ руй дод!");
    return Promise.reject(error);
  }
);

const axiosAuthRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosAuthRequest.interceptors.request.use(
  (config) => {
    const accessToken = sessionStorage.getItem("access_token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosAuthRequest.interceptors.response.use(
  (response) => response,
  async (error) => {
    const detailStr = error?.response?.data?.detail || "";
    const fixedJsonStr = detailStr.replace(/'/g, '"');
    try {
      const detailObj = JSON.parse(fixedJsonStr);
      if (detailObj.message) {
        toast.error(detailObj.message);
      } else {
        toast.error(detailStr);
      }
    } catch {
      toast.error(detailStr || "Непредвиденная ошибка.");
    }
    const {
      config,
      response: { data, status },
    } = error;
    const originalRequest = config;

    if (
      (data?.detail === "Invalid token or expired token." || status === 401) &&
      config
    ) {
      const refreshToken = sessionStorage.getItem("refresh_token");

      if (!refreshToken) {
        destroyToken();
        return Promise.reject(error);
      }

      try {
        const { data } = await axiosPublicRequest.post(
          "auth/v1/refresh/token",
          {},
          {
            headers: {
              Authorization: "Bearer " + refreshToken,
            },
          }
        );

        saveToken(data?.access_token, data?.refresh_token);

        originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
        return axiosAuthRequest(originalRequest);
      } catch (err) {
        destroyToken();
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

function saveToken(access_token, refresh_token) {
  sessionStorage.setItem("access_token", access_token);
  sessionStorage.setItem("refresh_token", refresh_token);
}

function destroyToken(navigate) {
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("refresh_token");
  sessionStorage.removeItem("userRole");
  if (navigate) {
    navigate("/");
  } else {
    document.location.href = "/";
  }
}

export { axiosPublicRequest, axiosAuthRequest, destroyToken, saveToken };
